import { Flex, Text } from '@chakra-ui/react';
import { WarningUpIcon } from '@halo/ui-chat-react';
import { useMemo } from 'react';

export type ReportNoticeType = 'user_report_exceeded' | 'group_report_exceeded' | 'group_banned';

export interface ReportNoticeProps {
  type?: ReportNoticeType;
  visible?: boolean;
}

export default function ReportNotice({ type, visible = true }: ReportNoticeProps) {
  const { t } = useTranslation();

  const noticeConfig = useMemo(() => {
    switch (type) {
      case 'user_report_exceeded':
        return {
          message: t('general.userReportExceeded'),
        };
      case 'group_report_exceeded':
        return {
          message: t('general.userReportExceeded'),
        };
      case 'group_banned':
        return {
          message: t('general.groupBanned'),
        };
      default:
        return null;
    }
  }, [type, t]);

  if (!visible || !type || !noticeConfig) {
    return null;
  }

  return (
    <Flex
      align="center"
      justify="center"
      gap="2"
      bg="rgb(255 0 21 / 10%)"
      p="3"
      backdropFilter="blur(48px)"
    >
      <WarningUpIcon />
      <Text as="span" color="fg" fontWeight="medium" fontSize="sm">
        {noticeConfig.message}
      </Text>
    </Flex>
  );
}
